import React from "react";

import {
  getProfileTypeColor,
  ProfileTypeName,
  ProfileTypeNames
} from "@platformsh/observability-graph/ContinuousProfiling";

import ProfileTypeIconCpu from "./ProfileTypeIconCpu";
import ProfileTypeIconMemory from "./ProfileTypeIconMemory";
import ProfileTypeIconWallTime from "./ProfileTypeIconWallTime";
import * as S from "./styles";

type ProfileTypeBulletProps = {
  profileTypeName: ProfileTypeName;
};

const ProfileTypeIcon = ({ profileTypeName }: ProfileTypeBulletProps) => {
  switch (profileTypeName) {
    case ProfileTypeNames.CPU:
      return (
        <S.Layout $color={getProfileTypeColor(profileTypeName)}>
          <ProfileTypeIconCpu />
        </S.Layout>
      );
    case ProfileTypeNames.WALL_TIME:
    case ProfileTypeNames.WALL:
      return (
        <S.Layout $color={getProfileTypeColor(profileTypeName)}>
          <ProfileTypeIconWallTime />
        </S.Layout>
      );
    case ProfileTypeNames.INUSE_SPACE:
    case ProfileTypeNames.SPACE:
    case ProfileTypeNames.ALLOC_SPACE:
      return (
        <S.Layout $color={getProfileTypeColor(profileTypeName)}>
          <ProfileTypeIconMemory />
        </S.Layout>
      );
  }

  return (
    <S.Layout $color={getProfileTypeColor(profileTypeName)}>
      <S.EmptyIcon $color={getProfileTypeColor(profileTypeName)} />
    </S.Layout>
  );
};

export default ProfileTypeIcon;
